
import http from '@/components/services/http-common'
import DataFilter from '@/components/DataFilter'
import CreateDialogMan1 from '../Man1Create.vue'
import * as moment from "moment/moment"

export default {
    name: "Attendance",
    components: {
        'data-filter': DataFilter,
        'create-dialog-man1': CreateDialogMan1,
    },
    props: ["breadcrumbs", "icon"],
    watch: {
        dialog(val) {
            if (!this.dialog)
                this.item = null;
        },
        tableParams: {
            handler(val) {
                this.fetchData();
            },
            deep: true,
        },
        filters: {
            handler(val) {
                this.tableParams.page = 1;
                this.fetchData();
            },
            deep: true,
        },
        month(val) {
            this.fetchData();
        }
    },
    computed: {
        params: function () {
            return { ...this.tableParams, ...this.filters }
        },
        employeeCode() {
            let user = JSON.parse(localStorage.getItem("user"));
            return user?.employeeCode;
        },
        filteredItems() {
            let result = this.items;
            if (this.departmentSearch) {
                let lowerSearch = this.departmentSearch.toLowerCase();
                result = result.filter(item => item.departmentName && item.departmentName.toLowerCase().includes(lowerSearch));
            }
            return result;
        },
        totalCount() {
            return this.filteredItems.length;
        },
        departments() {
            const depts = this.items.map(item => item.departmentName).filter(name => !!name);
            return [...new Set(depts)].sort();
        },
        pendingCount() {
            return this.filteredItems.filter(item => {
                if (this.employeeCode == item.acceptBy1) return item.l1Accept == 0;
                if (this.employeeCode == item.acceptBy2) return item.l2Accept == 0;
                return false;
            }).length;
        },
        confirmedCount() {
            return this.filteredItems.filter(item => {
                if (this.employeeCode == item.acceptBy1) return item.l1Accept == 1;
                if (this.employeeCode == item.acceptBy2) return item.l2Accept == 1;
                return false;
            }).length;
        },
        rejectedCount() {
            return this.filteredItems.filter(item => {
                if (this.employeeCode == item.acceptBy1) return item.l1Accept == 4;
                if (this.employeeCode == item.acceptBy2) return item.l2Accept == 4;
                return false;
            }).length;
        }
    },
    data() {
        return {
            ROOT_URL: "quitRequests/",
            exportPrompt: false,
            month: moment().format("YYYY-MM"),
            //filter
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
            },
            filters: {
                code: null,
                employeeCode: null,
                employeeName: null,
                deparmentCode: null,
                shiftCode: null,
            },
            departmentSearch: null,
            shifts: [],
            rowCount: 0,

            filter: {
                menu: false,
                search: "",
                searchAttr: "name",
                searchAttrs: undefined,
                FilterAttrs: [],
                FilterOn: ["DepartmentTypeCode"],

                from: undefined,
                to: undefined,
                fromOns: [
                ],
                fromOn: "",
            },

            // VIEW DATA
            filterOpen: 1,

            //DATA TABLE
            totalItem: 0,
            items: [],
            search: "",
            options: {},
            isLoading: true,
            denyNote: '',
            dialogDeny: false,
            dialogGopy: false,
            gopyNote: '',
            gopyFile: null,
            gopyFileUrl: '',
            gopyAction: 1,
            dialogConfirm: false,
            confirmNote: '',
            confirmFile: null,
            confirmFileUrl: '',

            viewImageDialog: false,
            currentImageUrl: '',

            dialog: false, item: null,
            dialogDelete: false,
            targetItem: undefined,

            globalSearch: '',
            headers: [
                { text: 'Thao tác', value: 'actions', width: '6rem' },
                { text: 'Mã', align: 'start', value: 'code', width: '4rem' },
                { text: 'Loại', align: 'start', value: 'quitTypeName', width: '6rem' },
                { text: '', align: ' d-none', value: 'quitEmployeeCode' },
                { text: 'Nhân viên', align: 'start', value: 'employeeInfo', width: '13rem' },
                { text: 'Thời gian', align: 'start', value: 'durationInfo', width: '11rem' },
                { text: 'Lý do', align: 'start', value: 'quitReason', width: '10rem' },
                { text: 'Tiến trình duyệt', align: 'start', value: 'acceptBy1', width: '16rem' },
                { text: 'HR', align: 'center', value: 'acceptBy3', width: '6rem' },
                { text: 'Đính kèm', align: 'center', value: 'attachment', width: '5rem' },
                { text: 'Ngày gởi', align: 'start', value: 'sendDate', width: '6rem' },
            ],
        }
    },
    methods: {
        formatTime(value) {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
        },
        viewImage(url) {
            this.currentImageUrl = url;
            this.viewImageDialog = true;
        },
        fetchData() {
            return http.get(this.ROOT_URL + "manager", {
                params: {
                    month: this.month
                }
            })
                .then(res => {
                    this.items = res.data.data;
                    this.isLoading = false;
                });
        },
        edit(item) {
            this.item = item;
            this.dialog = true;
        },
        checkAndOpenConfirm(item) {
            if (item.acceptBy1) {
                let name = item.acceptBy1Name ? item.acceptBy1Name : "Người góp ý";
                if (item.l1Accept == 0) {
                    if (!confirm(`${name} chưa có ý kiến. Bạn có chắc chắn muốn tiếp tục duyệt?`)) {
                        return;
                    }
                } else if (item.l1Accept == 4) {
                    if (!confirm(`${name} đã từ chối, bạn có muốn duyệt?`)) {
                        return;
                    }
                }
            }
            this.targetItem = item;
            this.dialogConfirm = true;
        },

        checkAndOpenDeny(item) {
            if (item.acceptBy1) {
                let name = item.acceptBy1Name ? item.acceptBy1Name : "Người góp ý";
                if (item.l1Accept == 0) {
                    if (!confirm(`${name} chưa có ý kiến. Bạn có chắc chắn muốn tiếp tục từ chối?`)) {
                        return;
                    }
                }
            }
            this.targetItem = item;
            this.dialogDeny = true;
        },

        remove(item) {
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            // http.delete(this.ROOT_URL+this.targetItem.code).then(res => {
            //     this.fetchData();
            //     this.dialogDelete = false;
            // })
        },

        uploadGopyFile(file) {
            if (!file) {
                this.gopyFileUrl = '';
                return;
            }
            let formData = new FormData();
            formData.append('file', file);
            http.post("NasUploads?folder=QuitRequest", formData).then(res => {
                this.gopyFileUrl = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
            });
        },

        uploadConfirmFile(file) {
            if (!file) {
                this.confirmFileUrl = '';
                return;
            }
            let formData = new FormData();
            formData.append('file', file);
            http.post("NasUploads?folder=QuitRequest", formData).then(res => {
                this.confirmFileUrl = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
            });
        },

        gopyManager() {
            if (this.targetItem == undefined) return;

            let params = { note: this.gopyNote };
            if (this.gopyFileUrl) {
                params.attachment = this.gopyFileUrl;
            }

            let actionText = this.gopyAction == 1 ? "accept/" : "deny/";
            return http.get(this.ROOT_URL + "manager/" + actionText + this.targetItem.code, { params }).then(() => {
                this.$emit("fetch");
                this.dialogGopy = false;
                this.fetchData();
                this.gopyNote = '';
                this.gopyFile = null;
                this.gopyFileUrl = '';
                this.gopyAction = 1;
            })
        },

        confirmManager() {
            if (this.targetItem == undefined) return;

            let params = { note: this.confirmNote };
            if (this.confirmFileUrl) {
                params.attachment = this.confirmFileUrl;
            }

            return http.get(this.ROOT_URL + "manager/accept/" + this.targetItem.code, { params }).then(() => {
                this.$emit("fetch");
                this.dialogConfirm = false;
                this.fetchData();
                this.confirmNote = '';
                this.confirmFile = null;
                this.confirmFileUrl = '';
            })
        },

        denyManager1() {
            if (this.targetItem == undefined) return;
            return http.get(this.ROOT_URL + "manager/deny/" + this.targetItem.code, {
                params: {
                    note: this.denyNote
                }
            }).then(() => {
                this.$emit("fetch");
                this.dialogDeny = false;
                this.fetchData();
                this.denyNote = '';
            })
        },
    },
    created() {
        this.fetchData();
    },

}